import { Routes } from '@angular/router';
import { Complete } from './components/complete/complete';
import { DeficiencyLogin } from './components/deficiency-login/deficiency-login';
import { LTMDOC } from './components/ltmdoc/ltmdoc';

export const routes: Routes = [ 
  { path: '', pathMatch: 'full', redirectTo: 'deficiency-login' },
  { path: 'deficiency-login', component: DeficiencyLogin },
  { path: 'ltmdoc', component: LTMDOC },
  { path: 'complete', component: Complete },
 /* { path: '**', redirectTo: 'tpp-instructions' },*/

];
